@if (!isLoading) {
    <mat-card appearance="outlined" class="mat-elevation-z0">
        <mat-card-header>
            <mat-card-title>{{ title }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ng-content />
        </mat-card-content>
        <mat-card-actions>
            @for (button of currentButtons; track button; let i = $index) {
                <button
                    mat-button
                    (click)="onButtonClick(button, $event)"
                    [disabled]="button.isDisabled"
                    color="{{ button.color }}"
                    class="modal-action-btn"
                    [class]="button.iconClasses()">
                    {{ button.caption | translate }}
                </button>
            }
        </mat-card-actions>
    </mat-card>
}
